module.exports = __webpack_public_path__ + "35b592b364637cf4dfc8dc6ede771ac9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/filter_folder_2x.png
// module id = 16
// module chunks = 0 1 2 3 4